module.exports = __webpack_public_path__ + "img/TCDC_Logo_White.e195032c.png";